import React, { useEffect, useState, useMemo } from "react";

import Page from "../../components/Page";
import Banner from "../../components/banner";
import ProductItem from "../../components/productItem";
import {
  categoryGet_req,
  filterProducts_req,
  getAllProduct_req,
  getFilterSize_req,
  search_req,
} from "../../api/api";

import ReactPaginate from "react-paginate";
import { useRouter } from "next/router";
import { useIntl } from "react-intl";
import SelectCustom from "../../components/select";
import NotFoundIcon from "../../assets/images/browser.png";
import { useSelector } from "react-redux";
import LeftArrow from "../../assets/images/icons/left-chevron.png";
import RightArrow from "../../assets/images/icons/right-chevron.png";
import SeachBlackIcon from "../../assets/images/icons/search-black-icon.png";

const Shop = (query) => {
  const router = useRouter();

  const intl = useIntl();
  const queryData = query.item;

  const excludedProductIds = [
    920, 951, 919, 867, 865, 746, 733, 717, 705, 570, 513, 436, 413, 401, 393,
    391, 273, 388, 270, 264, 253, 245, 217, 210, 179, 177, 176, 172, 137, 96,
    86, 55, 41, 17,
  ];

  const filterExcludedProducts = (products) => {
    if (!Array.isArray(products)) return products;

    if (
      typeof window !== "undefined" &&
      window.location.hostname === "handle-brand.ru"
    ) {
      return products.filter(
        (product) => !excludedProductIds.includes(product.id)
      );
    }
    return products;
  };

  const [productList, setProductList] = useState([]);
  const [state, setState] = useState({
    search: query.search ? query?.search : "",
  });
  const [productsPage, setProductsPage] = useState(null);
  const [sizeData, setSizeData] = useState([]);

  const [changeCategory, setChangeCategory] = useState("");
  const [changeSize, setChangeSize] = useState(
    query?.changeSize ? query.changeSize : ""
  );
  const [allCategory, setAllCategory] = useState([]);
  const [priceState, setPriceState] = useState({
    minPrice: query?.minPrice ? query.minPrice : "",
    maxPrice: query?.maxPrice ? query.maxPrice : "",
  });
  const currentPageItem = Number(router?.query?.item);
  const [page, setPage] = useState(router?.query?.id ? router.query.id : 1);
  const [hostName, setHostName] = useState("");

  const currentPageQuery = router.query.id;
  const locale = useSelector((state) => state.global.locale);

  const getCategoryReq = async () => {
    const getCategoryReqData = await categoryGet_req();

    setAllCategory(getCategoryReqData);
  };
  const windowHost = async () => {
    const data = await window.location.hostname;
    setHostName(data);
  };

  useEffect(() => {
    if (router?.query?.search) {
      searchReq();
    } else {
      if (
        currentPageItem ||
        priceState?.minPrice > 0 ||
        priceState?.maxPrice < 999999
      ) {
        filteredData([currentPageItem], changeSize);
      }
    }

    getFilterSizeData(query.item);
  }, [query]);
  useEffect(() => {
    windowHost();
    getCategoryReq();
  }, [locale]);
  const handleChange = (evt) => {
    const value = evt.target.value;
    setState({
      ...state,
      [evt.target.name]: value,
    });
  };

  const getFilterSizeData = async (value) => {
    const dataValue = Number(value);
    const filterReq = await getFilterSize_req([dataValue]);

    setSizeData(filterReq.data);
  };

  const onchangeRadio = async (evt) => {
    const value = Number(evt.target.value);

    setChangeCategory((evt.target.name = value));
    setChangeSize("");
    router.push(
      `/all/1?item=${value}${
        priceState.minPrice > 0 ? `&minPrice=${priceState.minPrice}` : ""
      }${priceState.maxPrice > 0 ? `&maxPrice=${priceState.maxPrice}` : ""}`
    );
  };

  const onchangeRadioSize = async (evt) => {
    const sizeValue = Number(evt.target.value);

    setChangeSize((evt.target.name = sizeValue));
    router.push(
      `/all/1?item=${query.item}&changeSize=${sizeValue}${
        priceState.minPrice > 0 ? `&minPrice=${priceState.minPrice}` : ""
      }${priceState.maxPrice > 0 ? `&maxPrice=${priceState.maxPrice}` : ""}`
    );
  };

  const handleChangePrice = async (evt) => {
    const value = evt.target.value;
    if (evt.target.name === "minPrice") {
      router.push(
        `/all/1?${
          router.query.item
            ? `item=${router.query.item}`
            : changeCategory
            ? `item=${changeCategory}`
            : ""
        }${changeSize > 0 ? `&changeSize=${changeSize}` : ""}${
          value > 0 ? `&minPrice=${value}` : ""
        }${priceState?.maxPrice > 0 ? `&maxPrice=${priceState.maxPrice}` : ""}`
      );
    }
    if (evt.target.name === "maxPrice") {
      router.push(
        `/all/1?${
          router.query.item
            ? `item=${router.query.item}`
            : changeCategory
            ? `item=${changeCategory}`
            : ""
        }${changeSize > 0 ? `&changeSize=${changeSize}` : ""}${
          priceState.minPrice > 0 ? `&minPrice=${priceState.minPrice}` : ""
        }${value > 0 ? `&maxPrice=${value}` : ""}`
      );
    }

    setPriceState({
      ...priceState,
      [evt.target.name]: value,
    });
  };

  const searchReq = async () => {
    const searchData = await search_req(
      state.search,
      currentPageQuery ? currentPageQuery : 1
    );
    if (searchData) {
      setPriceState({
        minPrice: "",
        maxPrice: "",
      });
    }
    // router.push(`/all/1`);
    setProductsPage(searchData);
    setProductList(filterExcludedProducts(searchData?.products));
  };
  const goSearch = () => {
    router.push(`/all/1?search=${state.search}`);
  };

  // const getProduct = async (data) => {
  //   const getProductData = await getProducts_req(data ? data : page);
  //   setProductsPage(getProductData);
  //   setProductList(getProductData.products);
  // };

  // useEffect(() => {
  //   if (state?.search?.length > 2) {
  //     searchReq();
  //   }else{

  //   }
  // }, [state?.search]);

  const filteredData = async (data, first, page) => {
    const dataQuery = Number(data);
    if (
      dataQuery > 0 ||
      currentPageItem > 0 ||
      priceState?.minPrice > 0 ||
      priceState?.maxPrice < 999999
    ) {
      const filterReq = await filterProducts_req(
        data && dataQuery > 0
          ? [dataQuery]
          : currentPageItem > 0
          ? [currentPageItem]
          : [],
        first ? first : undefined,
        priceState,
        currentPageQuery ? currentPageQuery : page
      );
      setProductsPage(filterReq.data);
      setProductList(filterExcludedProducts(filterReq?.data?.filteredProducts));
    } else {
      const response = await getAllProduct_req(
        currentPageQuery ? currentPageQuery : page
      );
      setProductsPage(response.data);
      setProductList(filterExcludedProducts(response?.data?.products));
    }
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      goSearch();
    }
  };

  const handleClick = async (data) => {
    const index = data.selected;

    setPage(index + 1);
    if (state.search?.length > 1 || query?.search?.length > 1) {
      router.push(
        `/all/${index + 1}?search=${
          state?.search?.length > 1 ? state?.search : query?.search
        }`
      );
    } else {
      if (router) {
        router.push(
          `/all/${index + 1}?${
            router.query.item
              ? `item=${router.query.item}`
              : `item=${changeCategory}`
          }${changeSize > 0 ? `&changeSize=${changeSize}` : ""}${
            priceState.minPrice > 0 ? `&minPrice=${priceState.minPrice}` : ""
          }${priceState.maxPrice > 0 ? `&maxPrice=${priceState.maxPrice}` : ""}`
        );
      } else if (
        !router.query.item &&
        (priceState?.minPrice == 0 || priceState?.minPrice?.length === 0)
      ) {
        router.push(`/all/${index + 1}`);
      }
    }
  };

  const meta = useMemo(() => {
    return {
      title: "Հուշանվերների Խանութսրահ | Ձեռքի Աշխատանքներ | Handle",
      description:
        "Ցանկանում ես գնել բնական փայտից  կոնյակի տակառ, ժամացույց, շախմատ, նարդի, ձեռնափայտ և այլ հուշանվերներ | Իմացիր ավելին այստեղ",
    };
  }, [router.query]);

  return (
    <Page meta={meta}>
      <div className="shop">
        <Banner
          title={`${
            query?.discount === "discount"
              ? intl.messages.discount
              : intl.messages.shop
          }`}
          currentPage={`${
            query?.discount === "discount"
              ? intl.messages.discount
              : intl.messages.shop
          }`}
        />
        <div className="wrapper">
          <div className="filter-section flex flex-ai-center flex-jc-between">
            <div className="filter-left flex flex-ai-center">
              <SelectCustom
                label={intl.messages.category}
                handleChange={onchangeRadio}
                name="changeCategory"
                value={currentPageItem ? currentPageItem : changeCategory}
                children={
                  <>
                    {!currentPageItem && (
                      <option
                        value=""
                        disabled
                      >
                        {intl.messages.selectOne}
                      </option>
                    )}
                    {allCategory?.data?.map((item, index) => (
                      <option
                        value={item.categoryId}
                        selected={
                          changeCategory
                            ? changeCategory === item.categoryId
                            : queryData === item.id
                        }
                      >
                        {item.name}
                      </option>
                    ))}
                  </>
                }
              />
              {sizeData?.length > 0 && (
                <div className="filter-category">
                  <SelectCustom
                    label={intl.messages.size}
                    handleChange={onchangeRadioSize}
                    name={intl.messages.size}
                    value={changeSize}
                    children={
                      <>
                        <option
                          value=""
                          disabled
                        >
                          {intl.messages.selectOne}
                        </option>
                        {sizeData?.map((item, index) => (
                          <option
                            value={item.id}
                            selected={item.id}
                          >
                            {item.name}
                          </option>
                        ))}
                      </>
                    }
                  />
                </div>
              )}

              <div className="field-item price-range">
                <span>{intl.messages.priceRange}</span>
                <div>
                  <input
                    type="number"
                    placeholder={intl.messages.from}
                    onChange={handleChangePrice}
                    value={priceState.minPrice}
                    name="minPrice"
                  />
                  <input
                    type="number"
                    placeholder={intl.messages.to}
                    onChange={handleChangePrice}
                    value={priceState.maxPrice}
                    name="maxPrice"
                  />
                </div>
              </div>
            </div>
            <div className="filter-right">
              <div className="field-item search-field">
                <span>{intl.messages.search}</span>
                <label className="search-label">
                  <input
                    type="text"
                    onChange={handleChange}
                    value={state.search}
                    name="search"
                    onKeyDown={handleKeyDown}
                  />
                  <button onClick={goSearch}>
                    <img
                      src={SeachBlackIcon.src}
                      alt=""
                    />
                  </button>
                </label>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap">
            {productList.length > 0 ? (
              productList?.map((item) => (
                <>
                  <ProductItem
                    image={item.image}
                    name={item.title}
                    size={item.size}
                    price={item.price}
                    code={item.code}
                    categoryName={item.categoryName}
                    tag={item.discount}
                    oldPriceData={true}
                    id={item.id}
                    currency={item.currency}
                    changeSize={changeSize}
                    minPrice={priceState.minPrice}
                    maxPrice={priceState.maxPrice}
                  />
                </>
              ))
            ) : (
              <div className="product-not-found">
                <img
                  src={NotFoundIcon.src}
                  alt=""
                />
                <h4>{intl.messages.productNotFound}</h4>
              </div>
            )}
          </div>
          {productsPage?.pagesCount > 1 ? (
            <ReactPaginate
              previousLabel={
                <img
                  src={LeftArrow.src}
                  alt=""
                />
              }
              nextLabel={
                <img
                  src={RightArrow.src}
                  alt=""
                />
              }
              breakLabel={`...`}
              pageCount={productsPage?.pagesCount}
              marginPagesDisplayed={1}
              pageRangeDisplayed={3}
              onPageChange={(data) => handleClick(data)}
              containerClassName={"pagination justify-content-center"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextClassName={"page-item"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
              activeClassName={"active"}
              forcePage={currentPageQuery - 1}
            />
          ) : null}
        </div>
      </div>
    </Page>
  );
};
Shop.getInitialProps = ({ query }) => {
  return query;
};
export default Shop;
